export default __webpack_public_path__ + "static/restroom_b.2033fb45c141153ba0a2adea6314dab5.svg";